// Pages
export const homePageLink = `/`
export const blogsPageLink = `/blog`
export const blogsPageRssLink = `/blog/rss.xml`
